import DefaultHeroBannerImage from '@shared/assets/images/default-hero-banner.png';

interface HeroBannerProps {
    imageUrl?: string,
    altText?: string
}

const HeroBanner = ({
    imageUrl,
    altText
}: HeroBannerProps) => {
    return (
        <section className='mx-auto xl:container xl:px-4 overflow-hidden md:py-[14px]'>
            {
                imageUrl && (
                    <img
                        src={imageUrl}
                        alt={altText || 'Book Banner'}
                        className='w-full h-[93.75px] md:h-[170.5px] lg:h-[341px] object-cover rounded-0 xl:rounded-[12px] border-0 xl:border-2 border-white animate-in fade-in zoom-in-90 duration-300'
                        loading='lazy'
                        onError={(e) => {
                            e.currentTarget.src = DefaultHeroBannerImage;
                        }}
                    />
                )
            }
        </section>
    );
};

export default HeroBanner;
